import React, { Component } from 'react'
import { Button, Checkbox, Modal } from 'antd'
import _ from 'lodash'
import { Field } from '../../../../styles'
import { withTranslation } from 'react-i18next'
import './styles.scss'

class GroupPicker extends Component {
    state = {
        modalVisible: false,
        modalOrganization: null
    }

    handleChange = id => {
        const { onChange } = this.props
        if (onChange) {
            onChange(id)
        }
    }

    getFirstLetter = title => {
        return title ? title.charAt(0).toUpperCase() : ''
    }

    openModal = organization => {
        this.setState({
            modalVisible: true,
            modalOrganization: organization
        })
    }

    closeModal = () => {
        this.setState({
            modalVisible: false,
            modalOrganization: null
        })
    }
    handleConfirm = () => {
        this.closeModal()
    }

    render() {
        const { list, selectedGroups, t } = this.props
        const { modalVisible, modalOrganization } = this.state

        let filteredList = []
        if (!_.isEmpty(list) && Array.isArray(list)) {
            filteredList = list.filter(i => (i.groups || []).length)
        }

        return (
            <Field>
                <Field.Label>{t('labels:select_organization')}</Field.Label>
                <div className="main-org-group">
                    <div className="org-group-row">
                        {filteredList.map(organization => {
                            const { groups = [], id, logo, title } = organization
                            const selectedOrgGroups = groups.filter(i =>
                                selectedGroups.includes(i.id)
                            )
                            const checkedOrganization =
                                selectedOrgGroups.length === groups.length
                            const indeterminateOrganizationsStatus =
                                selectedOrgGroups.length &&
                                selectedOrgGroups.length < groups.length

                            return (
                                <div className="org-group-item-container" key={id}>
                                    <div
                                        className={`org-group-btn`}
                                        onClick={() => this.openModal(organization)}
                                    >
                                        <div className="org-checkbox-wrapper">
                                            <Checkbox
                                                checked={checkedOrganization}
                                                indeterminate={indeterminateOrganizationsStatus}
                                            />
                                        </div>
                                        {logo ? (
                                            <img
                                                src={logo.link}
                                                alt={title}
                                                className="org-image"
                                            />
                                        ) : (
                                            <div className="org-initial">
                                                {this.getFirstLetter(title)}
                                            </div>
                                        )}
                                        <div className="org-name">
                                            {title}
                                        </div>
                                    </div>

                                    {modalVisible &&
                                        modalOrganization &&
                                        modalOrganization.id === organization.id && (
                                            <Modal
                                                title={`Groups for ${modalOrganization.title}`}
                                                visible={modalVisible}
                                                onCancel={this.closeModal}
                                                className="org-of-marketplace"
                                                footer={[
                                                    <Button key="cancel" onClick={this.closeModal}>
                                                        {t('buttons:cancel')}
                                                    </Button>,
                                                    <Button
                                                        key="confirm"
                                                        type="primary"
                                                        onClick={this.handleConfirm}
                                                    >
                                                        {t('buttons:confirm')}
                                                    </Button>
                                                ]}
                                            >
                                                <div className="org-all-list">
                                                    {groups.map(group => (
                                                        <div
                                                            key={group.id}
                                                            className="org-group-selection-item"
                                                            onClick={() => this.handleChange(group.id)}
                                                        >
                                                            <Checkbox
                                                                checked={selectedGroups.includes(group.id)}
                                                            />
                                                            <span className="group-name">{group.title}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </Modal>
                                        )}
                                </div>
                            )
                        })}
                    </div>
                </div>
            </Field>
        )
    }
}

export default withTranslation()(GroupPicker)
